import type React from 'react';
import Image from 'next/image';

interface Props {
  quote: string;
  photoUrl: string;
  profile: string;
}

const TestimonialItem: React.FC<Props> = ({
  quote,
  photoUrl,
  profile,
}: Props) => (
  <div className="flex flex-col items-center py-8">
    <div className="bg-white rounded-xl p-8 shadow-sm max-w-2xl mx-auto">
      <div className="text-center mb-6">
        <svg
          className="w-10 h-10 mx-auto text-[#e55425]/30"
          fill="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
        </svg>
      </div>
      <blockquote className="font-serif text-xl text-[#1c1c1c] text-center leading-relaxed mb-6 italic">
        {quote}
      </blockquote>
      <div className="flex flex-col items-center">
        <div className="mb-3">
          <Image
            alt={`${profile} avatar`}
            src={photoUrl}
            height={56}
            width={56}
            className="rounded-full ring-2 ring-[#fbe4dc]"
          />
        </div>
        <div className="text-sm text-[#1c1c1c]/65 font-medium">{profile}</div>
      </div>
    </div>
  </div>
);

export default TestimonialItem;
